import Swal from 'sweetalert2';
import { append_active_organization_id, get_active_organization_id } from '@/utils/organization_profile';

export default {
create_group_discussion_topic() {
      this.prepare_discussion_description();

      if (!this.validate_discussion_topic()) {
        return;
      }

      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group_discussion/`,
        data: JSON.stringify({
          title: this.topic_name,
          description: this.description,
          group_id: this.$route.params.group_id,
          category_id: this.selected_category
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        contentType: 'application/json',
        success: (response) => {
          this.handle_created_discussion(response, true);
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
fetch_discussion_topics() {
      const requestData = append_active_organization_id({
        portal_id: this.$route.params.portal_id
      });
      const has_organization = !!get_active_organization_id();
      const endpoint = has_organization ? 'get_organization_topics' : 'get_portal_topics';

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/${endpoint}/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          var status = response.status
          if (status === "success") {
            this.destroy_discussion_table();
            this.disscussion_topics = this.get_discussion_response_topics(response);
            this.discussion_dashboard = this.get_discussion_response_dashboard(response);
            this.refresh_discussion_table();
            Swal.close()
          }

        },

        complete: () => {
          this.isLoading = false;
          Swal.close()
        }
      });
    },
filter_group_discussions() {
      const requestData = {
        group_id: this.$route.params.group_id
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/filter_group_discussions/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(requestData),
        success: (response) => {
          var status = response.status
          if (status === "success") {
            this.destroy_discussion_table();
            this.disscussion_topics = this.get_discussion_response_topics(response);
            this.discussion_dashboard = this.get_discussion_response_dashboard(response);
            this.refresh_discussion_table();
            Swal.close()
          }

        },

        complete: () => {
          this.isLoading = false;
          Swal.close()
        }
      });
    },
display_comment_modal(report_data) {
      this.report_data = report_data;
      this.comment_modal_visible = true;
      this.$nextTick(() => {
        $('#view_discussion_modal').modal('show');
      });
    },
edit_topic(topic) {
      this.showEditTopicForm = true;     // show the inline edit panel
      this.editTopicData.topic_id = topic.id;
      this.editTopicData.title = topic.name;
      this.editTopicData.description = topic.description || '';
      this.$nextTick(() => {
        if (this.$refs.quillDiscussionsUpdateEditorRef) {
          this.$refs.quillDiscussionsUpdateEditorRef.setHTML(this.editTopicData.description);
        }
      });
    },
save_topic_edits() {
      this.editTopicData.description = this.$refs.quillDiscussionsUpdateEditorRef.getHTML();
      this.editTopicData.description = this.editTopicData.description.replace(/<\/?p>/g, '').trim();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_topic/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          topic_id: this.editTopicData.topic_id,
          title: this.editTopicData.title,
          description: this.editTopicData.description
        }),
        success: (response) => {
          if (response?.status === "success" && response?.data) {
            const updated = response.data;

            // Update local array
            this.disscussion_topics = this.disscussion_topics.map(topic =>
              topic.id === updated.id ? updated : topic
            );

            Swal.close();
            this.showEditTopicForm = false;
            // Reset modal fields after DOM updates
            this.$nextTick(() => {
              this.editTopicData = {
                topic_id: null,
                title: "",
                description: ""
              };

              if (this.$refs.quillDiscussionsUpdateEditorRef) {
                this.$refs.quillDiscussionsUpdateEditorRef.setHTML("");
              }

              this.errors = {};
            });
          }
        }
      });
    },
delete_topic(topic_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_topic/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ topic_id: topic_id }),
        success: (response) => {
          var status = response.status
          if (status === "success") {
            this.destroy_discussion_table();
            this.disscussion_topics = this.disscussion_topics.filter(topic => topic.id !== topic_id);
            this.refresh_discussion_dashboard_from_list();
            this.refresh_discussion_table();
          }
        },
      });
    },
hide_comment() {
      this.comment_modal_visible = false;
      this.report_data = null;
      $('#view_discussion_modal').modal('hide');
    },
toggleDescription(topicId) {
      if (this.isExpanded(topicId)) {
        this.expandedTopics = this.expandedTopics.filter(id => id !== topicId);
      } else {
        this.expandedTopics.push(topicId);
      }
    },
isExpanded(topicId) {
      return this.expandedTopics.includes(topicId);
    },
displayedDescription(topic) {
    if (!topic.description) return '';

    // Show full description if expanded or shorter than maxLength
    if (this.isExpanded(topic.id) || topic.description.length <= this.maxLength) {
      return topic.description;
    }

    // Truncate and add ellipsis
    return `${topic.description.slice(0, this.maxLength)}...`;
  }
};

